<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
    <div class="min-h-screen bg-gray-50">
      <!-- 顶部导航 -->
      <header class="bg-white shadow-sm">
        <div class="max-w-7xl mx-auto px-4 py-4">
          <div class="flex items-center justify-between">
            <h1 class="text-2xl font-medium text-gray-900">批发点库存管理</h1>
            <div class="flex items-center space-x-4">
     
              <button class="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center space-x-2 !rounded-button">
                <i class="fas fa-cog"></i>
                <span>库存预警设置</span>
              </button>
              <button class="px-4 py-2 bg-white border border-gray-300 rounded-lg flex items-center space-x-2 !rounded-button">
                <i class="fas fa-download"></i>
                <span>导出数据</span>
              </button>
            </div>
          </div>
  
          <!-- 筛选区 -->
          <div class="mt-4 flex items-center space-x-4">
            
            <div class="relative"  v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>

            
   
            <div class="relative flex-1">
              <input type="text" placeholder="搜索商品名称/编码" class="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            </div>

             
                <!-- 日期范围选择 -->
                <!-- <div class="relative">
                <div class="flex items-center gap-2">
                <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
                    <span class="text-gray-500">至</span>
                    <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
                    </div>
                

                </div> -->

                <button @click="search" class="!rounded-button flex items-center px-4 py-2 bg-blue-600 text-white hover:bg-blue-700">
              查询
            </button>
          </div>
        </div>
      </header>
  
      <!-- 主体内容 -->
      <main class="max-w-7xl mx-auto px-4 py-6">
        <!-- 数据概览卡片 -->
        <div class="grid grid-cols-4 gap-4 mb-6">
          <div v-for="(card, index) in overviewCards" :key="index" class="bg-white rounded-lg p-4 shadow-sm">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">{{ card.title }}</p>
                <p class="text-2xl font-semibold mt-1">{{ card.value }}</p>
              </div>
              <!-- <div :class="`w-10 h-10 rounded-full flex items-center justify-center ${card.iconBg}`">
                <i :class="`${card.icon} text-white`"></i>
              </div> -->
            </div>
            <div class="mt-2 flex items-center text-sm">
              <span :class="card.trend === 'up' ? 'text-green-500' : 'text-red-500'">
                <i :class="card.trend === 'up' ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                {{ card.percentage }}
              </span>
              <span class="ml-1 text-gray-500">较上月</span>
            </div>
          </div>
        </div>
  
        <!-- 图表区域 -->
   
          <div class="bg-white rounded-lg p-4 shadow-sm">
            <h3 class="text-lg font-medium mb-4">库存趋势分析</h3>
            <div ref="lineChart" style="height: 300px"></div>
          </div>
    
  
        <!-- 商品列表 -->
        <div class="bg-white rounded-lg shadow-sm">
          <div class="p-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-medium">商品库存明细</h3>
              <div class="flex items-center space-x-4">
                <button class="px-4 py-2 bg-white border border-gray-300 rounded-lg flex items-center space-x-2 !rounded-button">
                  <span>商品分类</span>
                  <i class="fas fa-chevron-down text-gray-400"></i>
                </button>
                <button class="px-4 py-2 bg-white border border-gray-300 rounded-lg flex items-center space-x-2 !rounded-button">
                  <i class="fas fa-filter"></i>
                  <span>筛选</span>
                </button>
              </div>
            </div>
          </div>
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th v-for="header in tableHeaders" :key="header" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <img :src="item.image" class="w-10 h-10 rounded-lg object-cover" :alt="item.name">
                      <div class="ml-4">
                        <div class="text-sm font-medium text-gray-900">{{ item.name }}</div>
                        <div class="text-sm text-gray-500">{{ item.code }}</div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.category }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.stock }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.amount }}</td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span :class="`px-2 py-1 text-xs font-medium rounded-full ${item.status === '正常' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`">
                      {{ item.status }}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.lastInDate }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.lastOutDate }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button class="text-blue-600 hover:text-blue-900 !rounded-button">编辑</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="px-4 py-3 border-t border-gray-200">
            <div class="flex items-center justify-between">
              <div class="text-sm text-gray-700">
                显示 1 到 10 条，共 97 条
              </div>
              <div class="flex items-center space-x-2">
                <button class="px-3 py-1 border border-gray-300 rounded-lg text-sm !rounded-button">上一页</button>
                <button class="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm !rounded-button">1</button>
                <button class="px-3 py-1 border border-gray-300 rounded-lg text-sm !rounded-button">2</button>
                <button class="px-3 py-1 border border-gray-300 rounded-lg text-sm !rounded-button">3</button>
                <button class="px-3 py-1 border border-gray-300 rounded-lg text-sm !rounded-button">下一页</button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  
  import StatisticsApi from '@/api/statistics.js';
  import Warehouse_managementApi from '@/api/warehouse_management.js';

  export default {
    name: 'App',
    data() {
      return {
        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
        isuse:0,
        selectedSuppliers: {'store_name':""},
        showSupplierDropdowns: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,

        form:{
            startDate: '',
            endDate: '',
            supply_id:""
        },
        overviewCards: [
        ],
        tableHeaders: ['商品信息', '分类', '库存数量', '库存金额', '状态', '最近入库', '最近出库', '操作'],
        tableData: [
          {
            id: 1,
            name: '高级办公椅',
            code: 'SKU-001238',
            category: '办公家具',
            stock: 234,
            amount: '￥46,800',
            status: '正常',
            lastInDate: '2024-01-15',
            lastOutDate: '2024-01-20',
            image: 'https://ai-public.mastergo.com/ai/img_res/abc5a49092c3e8187b8f56db87984c27.jpg'
          },
          {
            id: 2,
            name: '人体工学键盘',
            code: 'SKU-001536',
            category: '电子设备',
            stock: 89,
            amount: '￥17,800',
            status: '预警',
            lastInDate: '2024-01-12',
            lastOutDate: '2024-01-18',
            image: 'https://ai-public.mastergo.com/ai/img_res/e39e4836f35a3a180c9d705f88ced7eb.jpg'
          },
          {
            id: 3,
            name: '4K显示器',
            code: 'SKU-001892',
            category: '电子设备',
            stock: 156,
            amount: '￥234,000',
            status: '正常',
            lastInDate: '2024-01-10',
            lastOutDate: '2024-01-16',
            image: 'https://ai-public.mastergo.com/ai/img_res/02ed2e1bc91661f267797c94796b5c1a.jpg'
          }
        ]
      };
    },
    mounted() {

        var self = this;
        this.getInas({},function(res){
        self.isuse = res
        })
        this.search();
        this.getSupplys();
       
    //   this.initPieChart();
    //   this.initLineChart();
    },
    methods: {
        search(){
            this.getInventoryOverview();
        },
        getInventoryOverview(){
            let self = this;
            StatisticsApi.getInventoryOverview(self.form, true)
            .then(res => {
                self.overviewCards = res.data;
            })
            .catch(error => {});   
        },
        getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
        this.form.store_id = "";
      },
      toggleSupplierDropdowns() {
        this.showSupplierDropdowns = !this.showSupplierDropdowns;
        
      },
      initPieChart() {
        const pieChart = echarts.init(this.$refs.pieChart);
        const option = {
          animation: false,
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '5%',
            left: 'center'
          },
          series: [
            {
              name: '库存状态',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 40,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: 1048, name: '正常' },
                { value: 735, name: '预警' },
                { value: 580, name: '积压' },
                { value: 484, name: '缺货' }
              ]
            }
          ]
        };
        pieChart.setOption(option);
      },
      initLineChart() {
        const lineChart = echarts.init(this.$refs.lineChart);
        const option = {
          animation: false,
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [820, 932, 901, 934, 1290, 1330, 1320],
              type: 'line',
              smooth: true
            }
          ]
        };
        lineChart.setOption(option);
      }
    }
  };
  </script>
  
  <style scoped>
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/plus/existing_inventory/index/main.vue